






































import { computed, defineComponent } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';

const ALL_STRINGS = [
	'follow-button.following',
	'follow-button.follow',
	'follow-button.unfollow',
];

export default defineComponent({
	components: {
		CtaButton,
	},
	props: {
		isFollowing: Boolean,
		isLoading: Boolean,
	},
	setup(props, ctx) {
		const longestString = computed(() => ALL_STRINGS
			.map((str) => ctx.root.$t(str) as string)
			.sort((a, b) => b.length - a.length)[0]);
		return {
			longestString,
			ButtonPalettes,
		};
	},
});
